import React from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'

import Container from '@material-ui/core/Container'
import Layout from '../Layout'

import InvoicePanel from '../../../utils/CommonFunctionality/MyBidsPanel/Invoices'
import DashboardLayout from '../DashboardLayout'

const TabPanel = ({ children, value, index, ...other }) => {
    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={3}>{children}</Box>}
        </Typography>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

const PurchaseHistory = (props) => {
    return (
        <>
            <Layout props={props}>
                <div className="GFdashWrapperContainer">
                    <DashboardLayout title="Purchase History">
                        <Container className="db-bids-wrapper mt-4 lq-db-table">
                            <InvoicePanel
                                isGFTransPanel={true}
                                locationParam={false}
                                isPrime={true}
                            />
                        </Container>
                    </DashboardLayout>
                </div>
            </Layout>
        </>
    )
}

export default PurchaseHistory
